
export const headerIndexBase = 100000000
export const footerIndexBase = 10000
